import { Group, Drawer, Box } from '@mantine/core';
import { navListCustormerWithChat, navListWorkSupport } from 'constants/stringConstants';
import { Link } from 'react-router-dom';
import { NavList } from '../NavList';
import { useDisclosure } from '@mantine/hooks';
import type { RootState } from 'redux/store';
import { useDispatch, useSelector } from 'react-redux';
import logoDark from './img/logoDark.svg';
import iconLogo from './img/iconLogo.svg';
import styles from './NavMobile.module.scss';
import { ReactComponent as IconBurger } from './img/iconBurger.svg';
import { ReactComponent as IconClose } from './img/iconClose.svg';
import { UserInfo } from '../UserInfo';
import { Button } from 'ui/Button';
import plus from 'assets/img/navSvg/plus.svg';
import { Avatar } from 'components/Avatar';
import { useGetAlertsCastomerQuery } from 'redux/Api/alertsWorkSupportApi/alertsWorkSupportApi';
import { useEffect, useRef } from 'react';
import { addEvent } from 'redux/webSocket/slice';

type NavMobileProps = {
  unreadMessagesSupport?: number;
  unreadMessagesOrderChat?: number;
};

export const NavMobile = ({
  unreadMessagesSupport = 0,
  unreadMessagesOrderChat = 0,
}: NavMobileProps) => {
  const role = localStorage.getItem('role') || 'worksupport';
  const dispatch = useDispatch();

  const { name, avatar } = useSelector((state: RootState) => state.authSlice);
  const [menuOpened, { close, open }] = useDisclosure(false);

  const isWorksupport = role === 'worksupport';
  const { data: alerts, refetch } = useGetAlertsCastomerQuery(undefined, {
    skip: isWorksupport,
  });
  const websocketState = useSelector((state: RootState) => state.websocket);
  const prevWebsocketLengthRef = useRef<number>(websocketState.length);

  useEffect(() => {
    if (isWorksupport) return;
    const result = alerts?.data.map((name: any) => name);
    result?.forEach((alert: any) => {
      return dispatch(addEvent({ alert }));
    });
  }, [alerts, dispatch, isWorksupport]);

  useEffect(() => {
    if (isWorksupport) return;
    const currentLength = websocketState.length;
    const prevLength = prevWebsocketLengthRef.current;

    if (prevLength > 0 && currentLength < prevLength) {
      refetch();
    }

    prevWebsocketLengthRef.current = currentLength;
  }, [websocketState.length, refetch, isWorksupport]);

  return (
    <>
      <Group justify='space-between' pt='8px'>
        <div onClick={open} className={styles.burgerWrapper} id='burger-menu'>
          <IconBurger />
        </div>

        <Link to={'/orders'} className={styles.logoLink}>
          <img className={styles.logo} src={logoDark} alt='Скилла Работа' />
        </Link>

        <Link to={'/profile'} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div className={styles.root_avatar}>
            {avatar ? (
              <img className={styles.avatar} src={avatar} alt={name} />
            ) : (
              <Avatar
                avatar={avatar}
                statusActive=''
                id={1}
                name={name}
                height={'32px'}
                width={'32px'}
              />
            )}
          </div>
        </Link>
      </Group>

      <Drawer
        opened={menuOpened}
        size='100%'
        onClose={close}
        withCloseButton={false}
        zIndex={10000}
        styles={{
          content: { backgroundColor: '#0F1E2F' },
          body: { padding: 0, height: '100%' },
        }}>
        <div className={styles.menuWrapper}>
          <Box>
            <Group justify='space-between' mb='20px' wrap='nowrap'>
              <Box h='48px' p='12px' onClick={close} style={{ cursor: 'pointer' }}>
                <IconClose />
              </Box>
              <img className={styles.logo} src={iconLogo} alt='Скилла Работа' />
              <Box w='40px' />
            </Group>
            <NavList
              navItems={
                role === 'worksupport' ? navListWorkSupport : navListCustormerWithChat
              }
              unreadMessagesSupport={unreadMessagesSupport}
              unreadMessagesOrderChat={unreadMessagesOrderChat}
            />
          </Box>
          {role !== 'director' ? (
            <Link to='/beneficiar/create'>
              <Button height='24' className={styles.btn} icon src={plus} theme='filed'>
                Заказчик
              </Button>
            </Link>
          ) : (
            <UserInfo close={close} />
          )}
        </div>
      </Drawer>
    </>
  );
};
